import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import sectors from "@/.sourceflow/sectors.json";

export const useJobSectors = () => {
  const collection = useSourceFlowCollection(sectors);
  return collection;
};

export default useJobSectors;
